import { render } from "./Titulo.vue?vue&type=template&id=19ef79de&bindings={\"texto\":\"props\"}"
import script from "./Titulo.vue?vue&type=script&lang=js"
export * from "./Titulo.vue?vue&type=script&lang=js"

import "./Titulo.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script